"use strict";

exports.__esModule = true;
exports["default"] = CircleDown;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.004.063C7.197.063.063 7.2.063 16.004c0 8.801 7.134 15.934 15.941 15.934 8.796 0 15.934-7.133 15.934-15.934C31.938 7.2 24.8.063 16.004.063zm10.482 16.502l-9.059 9.065a2.117 2.117 0 0 1-.667.434c-.225.1-.487.153-.751.153s-.527-.056-.78-.16a2.188 2.188 0 0 1-.618-.4l-9.083-9.092a1.965 1.965 0 0 1-.596-1.421c0-.547.213-1.056.605-1.432.349-.353.863-.56 1.403-.56.542 0 1.061.207 1.425.566l5.634 5.635V7.8c0-1.112.9-2.014 2.01-2.014s2.01.903 2.01 2.014v11.548l5.625-5.627c.365-.362.883-.57 1.421-.57s1.056.208 1.419.57c.78.787.78 2.061.002 2.844z"
  }));
}